import deviceService from '../../deviceService';

export default {
  async index(ctx) {
    switch (ctx.method) {
      case 'GET': {
        ctx.body = await deviceService.getScreenInfo();
        break;
      }
      case 'POST': {
        const body = await ctx.parseBodyJson();
        if (!['on', 'off'].includes(body.state)) {
          ctx.status = 400;
        } else {
          ctx.body = await deviceService[body.state === 'off' ? 'setScreenOff' : 'setScreenOn']();
        }
        break;
      }
      default:
        ctx.status = 404;
        break;
    }
  },
};
